import { FuseNavigationItem } from '@fuse/components/navigation';
import { PermissionsEnum } from '@shared/features/user/user-roles.interface';
import { ADMIN_NAVIGATION } from '@features/admin/constants/admin-navigation.constant';

export interface RoleFuseNavigationItem extends FuseNavigationItem {
  permissions?: PermissionsEnum[];
}

export const NAVIGATION_DATA: RoleFuseNavigationItem[] = [
  // {
  //   id: 'public',
  //   title: 'statistics',
  //   type: 'basic',
  //   icon: 'mat_outline:bar_chart',
  //   link: '/statistics',
  //   permissions: [PermissionsEnum.ADMIN],
  // },
  // {
  //   id: 'public',
  //   title: 'reports',
  //   type: 'basic',
  //   icon: 'heroicons_outline:document-text',
  //   link: '/reports',
  //   permissions: [PermissionsEnum.ADMIN],
  // },
  {
    id: 'applications',
    title: 'applications',
    type: 'basic',
    icon: 'mat_outline:list_alt',
    link: '/application/applications',
    permissions: [PermissionsEnum.OPERATOR, PermissionsEnum.BRIGADE, PermissionsEnum.SALES, PermissionsEnum.ACCOUNTANT],
  },
  {
    id: 'requests',
    title: 'requests',
    type: 'basic',
    icon: 'heroicons_outline:inbox-stack',
    link: '/admin/dashboard/brigade-requests',
    permissions: [PermissionsEnum.BRIGADE],
    badge: {
      title: '0',
      classes: 'rounded-xl bg-orange-500 px-1',
    },
  },
  ...ADMIN_NAVIGATION,
];
